"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveTokens = exports.mergeTokens = exports.getThemePalette = exports.applyTheme = exports.ThemeContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _definition = _interopRequireDefault(require("@amzn/meridian-tokens/theme/definition"));
var _color = _interopRequireDefault(require("@amzn/meridian-tokens/base/color"));
var _functional = require("./../_utils/functional");
var _upperFirst = _interopRequireDefault(require("./../_utils/upper-first"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var bluePalette = {
  palette50: _color["default"].colorBlue50,
  palette100: _color["default"].colorBlue100,
  palette200: _color["default"].colorBlue200,
  palette300: _color["default"].colorBlue300,
  palette400: _color["default"].colorBlue400,
  palette500: _color["default"].colorBlue500,
  palette600: _color["default"].colorBlue600,
  palette700: _color["default"].colorBlue700,
  palette800: _color["default"].colorBlue800,
  paletteMuted100: _color["default"].colorBlueMuted100,
  paletteMuted200: _color["default"].colorBlueMuted200,
  paletteMuted300: _color["default"].colorBlueMuted300,
  paletteMuted400: _color["default"].colorBlueMuted400,
  paletteMuted500: _color["default"].colorBlueMuted500,
  paletteMuted600: _color["default"].colorBlueMuted600,
  paletteMuted700: _color["default"].colorBlueMuted700
};
var orangePalette = {
  palette50: _color["default"].colorOrange50,
  palette100: _color["default"].colorOrange100,
  palette200: _color["default"].colorOrange200,
  palette300: _color["default"].colorOrange300,
  palette400: _color["default"].colorOrange400,
  palette500: _color["default"].colorOrange500,
  palette600: _color["default"].colorOrange600,
  palette700: _color["default"].colorOrange700,
  palette800: _color["default"].colorOrange800,
  paletteMuted100: _color["default"].colorOrangeMuted100,
  paletteMuted200: _color["default"].colorOrangeMuted200,
  paletteMuted300: _color["default"].colorOrangeMuted300,
  paletteMuted400: _color["default"].colorOrangeMuted400,
  paletteMuted500: _color["default"].colorOrangeMuted500,
  paletteMuted600: _color["default"].colorOrangeMuted600,
  paletteMuted700: _color["default"].colorOrangeMuted700
};
var tealPalette = {
  palette50: _color["default"].colorTeal50,
  palette100: _color["default"].colorTeal100,
  palette200: _color["default"].colorTeal200,
  palette300: _color["default"].colorTeal300,
  palette400: _color["default"].colorTeal400,
  palette500: _color["default"].colorTeal500,
  palette600: _color["default"].colorTeal600,
  palette700: _color["default"].colorTeal700,
  palette800: _color["default"].colorTeal800,
  paletteMuted100: _color["default"].colorTealMuted100,
  paletteMuted200: _color["default"].colorTealMuted200,
  paletteMuted300: _color["default"].colorTealMuted300,
  paletteMuted400: _color["default"].colorTealMuted400,
  paletteMuted500: _color["default"].colorTealMuted500,
  paletteMuted600: _color["default"].colorTealMuted600,
  paletteMuted700: _color["default"].colorTealMuted700
};

/**
 * Filter the tokens object down to only the ones needed for the current mode,
 * remove the mode suffix from the token name (themePageDefaultDark -> themePageDefault).
 * Resolve palette color values to use the current theme palette.
 * Include the palette colors with 'theme' prefix.
 */
var resolveTokens = function resolveTokens(palette, mode) {
  var resolvedThemeTokens = Object.fromEntries(Object.entries((0, _definition["default"])(palette)).filter(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
      key = _ref2[0];
    return key.endsWith((0, _upperFirst["default"])(mode));
  }).map(function (_ref3) {
    var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return [key.replace((0, _upperFirst["default"])(mode), ""), value];
  }));
  var themePaletteTokens = Object.fromEntries(Object.entries(palette).map(function (_ref5) {
    var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    return ["theme".concat((0, _upperFirst["default"])(key)), value];
  }));
  return _objectSpread(_objectSpread({}, resolvedThemeTokens), themePaletteTokens);
};

/**
 * Context for passing theme tokens down the tree.
 */
exports.resolveTokens = resolveTokens;
var ThemeContext = /*#__PURE__*/(0, _react.createContext)({
  palette: bluePalette,
  mode: "light",
  tokens: resolveTokens(bluePalette, "light")
});

/**
 * Merge two token objects together.
 */
exports.ThemeContext = ThemeContext;
var mergeTokens = (0, _functional.memoizeCurry)(function (a, b) {
  return _objectSpread(_objectSpread({}, a), b);
}, 1);

/**
 * Get the palette for a theme.
 */
exports.mergeTokens = mergeTokens;
var getThemePalette = function getThemePalette(paletteProp) {
  // If the palette is "orange" or "teal" then return the palette
  // definition object for that named palette.
  // NOTE: We will stop supporting "orange" and "teal" in 8.0.
  if (paletteProp === "orange") {
    return orangePalette;
  }
  if (paletteProp === "teal") {
    return tealPalette;
  }

  // If paletteProp is an object with a _version property, it's a custom palette.
  // So we verify that it's a supported version before passing it back as
  // the result. Today there's only one supported version, 1.0.
  if ((paletteProp === null || paletteProp === void 0 ? void 0 : paletteProp._version) === "1.0") {
    return paletteProp;
  }

  // Otherwise, return the Meridian classic "blue" palette by default.
  return bluePalette;
};

/**
 * Takes in an object of theme tokens and a function or object of tokens to
 * theme.
 */
exports.getThemePalette = getThemePalette;
var applyTheme = (0, _functional.memoizeCurry)(function (themeTokens, tokens) {
  return typeof tokens === "function" ? mergeTokens(tokens(themeTokens))(themeTokens) : tokens ? mergeTokens(tokens)(themeTokens) : themeTokens;
}, 1);
exports.applyTheme = applyTheme;